import { makeStyles } from 'tss-react/mui';

export const useCardStyles = makeStyles<{ spacing: number }>()(
  (theme, { spacing: cardSpacing }) => ({
    cardContainer: {
      padding: theme.spacing(3),
      marginBottom: theme.spacing(cardSpacing),
      borderRadius: 25
    }
  })
);
